import './header.less'

import {Icon, Image, MediaQuery} from '@codeurs/front'
import imecLogo40yearsWhite from 'assets/images/imec-logo-40years-white.svg'
import {EventModel} from 'models/EventModel'
import React, {Fragment, useState} from 'react'
import {LinkType} from 'types'
import {useIsDark} from 'util/hooks'
import {useTranslation} from 'util/i18n'
import {Link} from 'util/link'
import {style} from 'util/style'
import {EventLogo} from 'views/layout/eventlogo'
import {Theme} from 'views/theme'
import {HeaderMobilenav} from './header/headermobilenav'

// import imecLogoWhite from 'assets/images/imec-logo-white.svg'
// import imecLogo from 'assets/images/imec-logo.svg'

const styles = style('header', ['link', 'cta', 'dropout', 'hamburger'])

export type HeaderLeveledLink = {
	main_link: LinkType
	secondary_links: Array<LinkType>
}

export type HeaderType = {
	primary_menu: Array<HeaderLeveledLink>
	secondary_menu: Array<LinkType>
	cta?: LinkType
	mobile_menu: Array<LinkType>
}

export const Header: React.FC<{event: EventModel}> = ({event}) => {
	const isDark = useIsDark()
	const {primary_menu, secondary_menu, cta, mobile_menu} = event.header
	return (
		<div className={styles()}>
			<Theme.OuterContainer>
				<div className={styles('row')}>
					<div className={styles('left')}>
						<div className={styles('left-logo')}>
							<EventLogo event={event} />
						</div>
						<MediaQuery
							minWidth={1024}
							view={() => (
								<div className={styles('left-primary')}>
									{primary_menu.map(link => (
										<HeaderLeveledLink {...link} />
									))}
								</div>
							)}
						/>
					</div>
					<div className={styles('right')}>
						<MediaQuery
							maxWidth={1023}
							view={() => <HeaderHamburger links={mobile_menu} />}
						/>
						<MediaQuery
							minWidth={1024}
							view={() => (
								<Fragment>
									{cta && <HeaderCTA {...cta} />}
									<Link
										to="https://www.imec-int.com"
										target="_blank"
										className={styles('right-powered')}
										title="imec corporate website"
									>
										<span>Powered by</span>
										<span className={styles('right-powered-logo')}>
											{/* <Image
												{...(isDark ? imecLogoWhite : imecLogo)}
												alt="imec logo"
											/> */}
											<Image
												{...(isDark
													? imecLogo40yearsWhite
													: imecLogo40yearsWhite)}
												alt="imec logo"
											/>
										</span>
									</Link>
								</Fragment>
							)}
						/>
					</div>
				</div>
			</Theme.OuterContainer>
		</div>
	)
}

export const HeaderHamburger: React.FC<{links: Array<LinkType>}> = ({
	links
}) => {
	const [open, setOpen] = useState(false)
	const t = useTranslation('header')

	return (
		<Fragment>
			<button
				onClick={() => setOpen(!open)}
				className={styles.hamburger()}
				aria-label={t('hamburger.open_arialabel')}
			>
				<Icon icon="menu" />
			</button>
			<HeaderMobilenav
				open={open}
				onClose={() => setOpen(false)}
				links={links}
			/>
		</Fragment>
	)
}

export const HeaderCTA: React.FC<LinkType> = ({url, description, title}) => {
	if (!url) return null

	return (
		<Link to={url} className={styles.cta()}>
			{description || title}
		</Link>
	)
}

export const HeaderLink: React.FC<{
	description?: string
	url: string
}> = ({url, description}) => {
	if (!url) return null

	return (
		<Link to={url} className={styles.link()}>
			{description}
		</Link>
	)
}

export const HeaderLeveledLink: React.FC<HeaderLeveledLink> = ({
	main_link,
	secondary_links
}) => {
	if (!main_link) return null
	if (secondary_links && secondary_links.length > 0)
		return (
			<HeaderDropout main_link={main_link} secondary_links={secondary_links} />
		)
	return <HeaderLink {...main_link} />
}

export const HeaderDropout: React.FC<HeaderLeveledLink> = ({
	main_link,
	secondary_links
}) => {
	return (
		<div className={styles.dropout()}>
			<Link className={styles.dropout('title')} to={main_link.url}>
				<span className={styles.dropout('title-text')}>
					{main_link.description || main_link.title}
				</span>
				<span className={styles.dropout('title-icon')}>
					<Icon icon="chevron-down" />
				</span>
			</Link>
			<div className={styles.dropout('options')}>
				<div className={styles.dropout('options-flyout')}>
					{secondary_links.map(
						link =>
							link && (
								<Link to={link.url} className={styles.dropout('options-link')}>
									{link.description || link.title}
								</Link>
							)
					)}
				</div>
			</div>
		</div>
	)
}
